module.exports = __webpack_public_path__ + "img/IMG_7189_L.89f4e1fb.webp";